import { Icon } from "../icons/Icon";
import { cx } from "../utils/format";

/** The team discussion's one condensed item in a ticket's conversation (the discussion polish round, 2026-11-02; brief
 *  docs/briefs/discussion-polish-hours-editor-round.md rule 2): the mark "Discussion", "4 lines · Mia, Rikard and you · 2 h ago", "2 new" while
 *  the reader has unread lines, then the newest line's first words, or "Mia mentioned you" for an unread mention. One button: a click opens
 *  the discussion (the app decides where). Props in, events out; the words are the app's (`discussionDigestOf`). */
export function DiscussionDigest({ meta, text, fresh, mentioned, onOpen }: { meta: string; text: string; /** the reader's unread lines */ fresh: number; /** the text names an unread mention */ mentioned?: boolean; onOpen: () => void }) {
  return (
    <button type="button" className={cx("ob-discussion-digest", fresh > 0 && "ob-discussion-digest--fresh")} onClick={onOpen}>
      <span className="ob-discussion-digest__head">
        <span className="ob-discussion-digest__mark"><Icon name="chat" size="xs" />Discussion</span>
        <span className="ob-discussion-digest__meta">{meta}</span>
        {fresh > 0 && <span className="ob-discussion-digest__new">{fresh} new</span>}
      </span>
      <span className={cx("ob-discussion-digest__text", mentioned && "ob-discussion-digest__text--mention")}>{text}</span>
    </button>
  );
}
